export enum ApplicationCodeEnum {
    pointageCompagnons = 'POINTAGE_COMPAGNONS',
    betonLeon = 'BETON_LEON',
    locmat = 'LOCMAT',
    donneesInterimaires = 'DONNEES_INTERIMAIRES',
    kairnial = 'KAIRNIAL',
    donneesRh = 'DONNEES_RH',
    planningLivraisonChantier = 'PLANNING_LIVRAISON_CHANTIER',
    at360entites = 'AT360_ENTITES',
    at360chantier = 'AT360_CHANTIER',
    accueilChantier = 'ACCUEIL_CHANTIER',
    pointageChantier360 = 'POINTAGE_CHANTIER_360',
    formOutilsInfo = 'FORM_OUTILS_INFO',
    actionsBetonLeon = 'ACTIONS_BETON_LEON',
    taskAssignment = 'TASK_ASSIGNMENT',
    quartHeureSecurite = 'QUART_HEURE_SECURITE',
    echangeSecurite = 'ECHANGE_SECURITE',
    boosterBox = 'BOOSTER_BOX',
    catalogueServiceMateriel = 'CATALOGUE_SERVICE_MATERIEL',
    factureServiceMateriel = 'FACTURE_SERVICE_MATERIEL',
    achats360 = 'ACHATS_360',
    wifi = 'WIFI',
    stac = 'STAC',
    auditsLogements = 'AUDITS_LOGEMENTS',
    rendezVousLocataires = 'RENDEZ_VOUS_LOCATAIRES',
    documentationChantier = 'DOCUMENTATION_CHANTIER',
    ajoutLocatairesContacts = 'AJOUT_LOCATAIRES_CONTACTS',
    heureInsertion = 'HEURES_INSERTION',
    leBonFileon = 'BON_FILEON',
    kitDeCom = 'KIT_DE_COM',
    affichageReglementaire = 'AFFICHAGE_REGLEMENTAIRE',
    panneauChantierConnecte = 'PANNEAU_CHANTIER_CONNECTE',
    rpc = 'RPC',
}
